import axios from "axios";
// 创建axios对象
const request = axios.create({
    baseURL: "https://www.1-metals.com/", //基础路径，发请求的时候，路径当中会出现api
    timeout: 5000 //请求时间超过5秒
});
const token = localStorage.getItem('token');
// console.log(token)
// 添加请求拦截器,   在请求发送之前做一些操作
request.interceptors.request.use(
    request => {
        // window.addEventListener('setItemEvent', (e) => {
        //     console.log("监听到触发了localStorage.setItem事件", e)
        // })
        // 设置请求的头信息
        request.headers = {
            'Content-Type': 'application/json',
            token: localStorage.getItem('token'),
        }
        return request
    },
    error => {
        Promise.reject(error)
    }
)

// 添加响应拦截器   
request.interceptors.response.use(
    response => {
        //成功的回调函数：服务器响应数据回来以后，响应拦截器可以检测到，可以做一些事情。
        return response.data
    },
    error => {
        Promise.reject(error)
    }
)
// 把request暴露出去
export default request
